import { render, staticRenderFns } from "./secondary-menu.vue?vue&type=template&id=58775df2"
import script from "./secondary-menu.vue?vue&type=script&lang=js"
export * from "./secondary-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports